import { Pipe, PipeTransform } from '@angular/core';
import { transformStarRating } from './../components/review.constants';

@Pipe({
  name: 'starRatingNumber',
  standalone: false,
})
export class StarRatingPipe implements PipeTransform {
  transform(value: string): number {
    return transformStarRating(value);
  }
}
